// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1c6d7567","508":"03322150","817":"63f88040"}[chunkId] + ".chunk.js";
};